import { toastService } from "src/libraries/toast";
import { getNltdevskeletonsUseCase } from "./getNltdevskeletonsUseCase";
import { UpdateNltdevskeletonDto } from "../entity/nltdevskeletons/dto/update-category-dto";
import { nltdevskeletonsService } from "../entity/nltdevskeletons/NltdevskeletonsService";

export const updateNltdevskeletonUseCase = async (body: UpdateNltdevskeletonDto) => {
    try {        
        const formData = new FormData();
        Object.keys(body).forEach(key => {
            if (key === 'image' && body?.image && !body.image?.path?.includes('http')) {
                formData.append('image', body.image, body.image.name)
            } else if (key === 'image' && !body.image?.path?.includes('http')) {
                formData.append('image', 'null')
            } else if (body[key] !== null && body[key] !== undefined) {
                formData.append(key, body[key].toString());
            }
        });
        
        const response = await nltdevskeletonsService.update(body.id, formData);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getNltdevskeletonsUseCase();
        }
        return response;
    } catch (error) {
        console.warn('updateNltdevskeletonUseCase: ', error);
    }
}  